export const SIZE = {
  12: '12',
  16: '16',
  18: '18',
  20: '20',
  24: '24',
  32: '32',
}

export const SIZE_DEFAULT = SIZE[24]

export const COLOR = {
  black: 'black',
  green: 'green',
  lightGreen: 'lightGreen',
  lightGrey: 'lightGrey',
}

export const COLOR_DEFAULT = COLOR.black

export const ART = {
  solid: 'solid',
  light: 'light',
  thin: 'thin',
}

export const ART_DEFAULT = ART.light
